import { useForm } from "react-hook-form";
import Header from "../components/Header";
import {
  aguserStore,
  configStore,
  EntityV2Store,
  loginStore,
  ManageCRMStore,
  routerStore,
} from "../../state/CommonState";
import AguserApi from "../../state/AguserApi";
import { useSnapshot } from "valtio";
import { AgSelectNewCH } from "../../components/AgCustlist";
import LabeledTextField from "../../mui-components/LabeledTextField";
import PhoneField, { PhoneFieldnew } from "../../mui-components/PhoneField";
import { EmailTagsField } from "../../mui-components/AgAutoComplete";
import Utils from "../../util/Utils";
import { useEffect, useState } from "react";
import EntityV2Api from "../../state/entities-api";
import { loader } from "../../util/loader";
import { MultiSelectField } from "../../port-to-port-schedules/multi-select";
import Newapi from "../../state/new-api";
function EditCrm(props) {
  useSnapshot(ManageCRMStore);
  useSnapshot(aguserStore);
  useSnapshot(configStore);
  useSnapshot(loginStore);
  const Entity =  EntityV2Store.EntityRec
  const [valid, setValid] = useState(true);
  const [agActiveList, setAgActiveList] = useState([])
  const [agEntityActiveList, setAgEntityActiveList] = useState([])
  const [agEntityActiveListOrginal, setAgEntityActiveListOrginal] = useState([])
  const crmForm = useForm({
    defaultValues: ManageCRMStore.manageCRMRec,
  });
  const {
    control,
    watch,
    register,
    setValue,
    handleSubmit,
    reset,
    clearErrors,
    formState: { errors },
    trigger,
    getFieldState,
    getValues,
    setError
  } = crmForm;
  const formValues = watch();
  const outcomeVal = formValues["outcome"] || "";
  const isNeedsFollowUp =
    outcomeVal.toLowerCase().replace(/[\s-]/g, "") === "needsfollowup";
  const isView = props.mode === "view";
  const onSubmit = (data) => {
    if (
      !data ||
      !data.type ||
      data.type === "" ||
      !data.outcome ||
      data.outcome === "" ||
      !data.dateTime ||
      data.dateTime === "" ||
      !data.customerName ||
      data.customerName.trim() === "" ||
      !data.meetingNotes ||
      data.meetingNotes.trim() === "" ||
      !data.internalAttendees ||
      data.internalAttendees.length === 0 ||
      (isNeedsFollowUp && (!data.followUpDate || data.followUpDate === ""))
    ) {
      setValid(false);
      configStore.setModalMessage(`Please check the fields`);
    } else if (data.email && data.email.length > 0 && !Utils.isEmail(data.email)) {
      setError("email", {
        type: "manual",
        message: "Enter a valid email",
      });
      configStore.setModalMessage(`Please check the fields`);
    } else {
      data.entityId = Entity.entityId;
      if (!isNeedsFollowUp) {
        data.followUpDate = "";
      }
      loader.show();
      const callback = (d) => {
        console.log(d);
        loader.hide();
        if (props.mode == "new") {
          configStore.setModalMessage(`submitted successfully.`, [], false);
        } else {
          configStore.setModalMessage(`Updated successfully.`, [], false);
        }
        routerStore.managecrmTabView = "meetingDetails";
        routerStore.managecrmCurrentViewNew = "list";
      };
      EntityV2Api.AddCrm(data, callback);
    }
  };
  // Auto-fetch internal users if not already in store
  useEffect(() => {
    if (!aguserStore.list || aguserStore.list.length === 0) {
      AguserApi.getList();
    }
  }, []);

  useEffect(() => {
    if (props.mode == "new") {
      if (Entity.branch?.length === 1) {
        setValue("branch", Entity.branch[0].state);
      }
      setValue("type", "Phone Call");

      // Auto-predefine internal attendee if missing or undefined
      const currentInternal = getValues("internalAttendees");
      if (
        !currentInternal ||
        currentInternal.length === 0 ||
        !currentInternal[0]
      ) {
        const userEmail = loginStore.email || loginStore.userRec?.email;
        let defaultAttendee = "";
        if (userEmail && aguserStore.list && aguserStore.list.length > 0) {
          defaultAttendee = aguserStore.getName4email(userEmail) || "";
        }
        if (!defaultAttendee && loginStore.userRec?.firstName) {
          const user = loginStore.userRec;
          const fullName = `${user.firstName} ${user.lastName || ""}`.trim();
          defaultAttendee = `${fullName} (${user.email || userEmail})`.trim();
        }
        if (!defaultAttendee && userEmail) {
          defaultAttendee = userEmail;
        }
        if (defaultAttendee) {
          setValue("internalAttendees", [defaultAttendee]);
        }
      }
    }
  }, [setValue, aguserStore.list]);
  useEffect(()=>{
      const agactiveuserlist = () =>{
        let l = []
        for (let i = 0; i < aguserStore.list.length; i++) {
          let e = aguserStore.list[i]
          if(e['status']=="ACTIVE" && e['email'].indexOf(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`)!=-1){
            l.push(
              {
                label:`${e['firstName']} ${e['lastName']} (${e['email']})`,
                value:`${e['firstName']} ${e['lastName']} (${e['email']})`
              }
            )
          }
        }
        if(JSON.stringify(agActiveList)!=JSON.stringify(l)){
          setAgActiveList(l)
        }
      }
      agactiveuserlist()
    },[aguserStore.list])
  useEffect(()=>{
    if(isView){
      let l = []
      for (let i = 0; i < ManageCRMStore.manageCRMRec.externalAttendees.length; i++) {
        let e = ManageCRMStore.manageCRMRec.externalAttendees[i]
        l.push(
            {
              label:e,
              value:e
            }
          )
        
      }
      if(JSON.stringify(agEntityActiveList)!=JSON.stringify(l)){
          setAgEntityActiveList(l)
          setAgEntityActiveListOrginal(l)
        }
    }else{
    if(agEntityActiveList.length==0){
      const callback = (data) =>{
        let l = []
        for (let i = 0; i < data.length; i++) {
          let e = data[i]
          // if(e.status=='NEWREG' || e.status=='ACTIVE'){
          if( e.status=='ACTIVE'){
          l.push(
            {
              label:`${e['firstName']} ${e['lastName']} (${e['email']})`,
              value:`${e['firstName']} ${e['lastName']} (${e['email']})`
            }
          )
        }
        }
        if(JSON.stringify(agEntityActiveList)!=JSON.stringify(l)){
          setAgEntityActiveList(l)
          setAgEntityActiveListOrginal(l)
        }
      }
      Newapi.allEntityUsers(Entity.entityId,callback)
    }
    }
  },[])
  
  const onInputChangeValue = (e)=>{
    setAgEntityActiveList([...agEntityActiveListOrginal, ...[{label:e,value:e}]])
  }
  const externalChangeValue = (e)=>{
    e = e[e.length-1]
    let l = -1
    for (let i = 0; i < agEntityActiveListOrginal.length; i++) {
      const e1 = agEntityActiveListOrginal[i]['value']
      if(e1==e){
        l = 0
      }
    }
    if(l==-1){
      let k = [...agEntityActiveListOrginal, ...[{label:e,value:e}]]
      setAgEntityActiveListOrginal(k)
      setAgEntityActiveList(k)
    }
  }
  const handleChange = (e)=>{
    setValue("externalAttendees",e)
  }
  const handleChange1 = (e)=>{
    let k = []
    for (let i = 0; i < e.length; i++) {
      if(i==e.length-1){
        if(Utils.isEmail(e[i])){
          let val = aguserStore.getName4email(e[i])
          if(val != undefined){
            k.push(val)
          }
        }
      }else{
        k.push(e[i])
      }
    }
    const uniqueValues = [...new Set(k)];
    
    setValue("internalAttendees",uniqueValues)
  }
  const getvaild = (name, ch=true, rw=false) =>{
      if(!valid || !ch){
        if(!rw && (formValues[name]==undefined || formValues[name].length==0)){
          return false
        }else if(rw && (formValues[name]==undefined || formValues[name].length==0)){
            return true
        }
      }else{
        return true
      }
    }
    
  return (
    <>
      <Header
        heading={
          props.mode === "new" ? "Add Meeting Details" : "Edit Meeting Details"
        }
      >
        {" "}
      </Header>
      <div className="ml-2 mb-2">
        <h2 className="text-xl text-blue-900 text-[#2B3688]">{Entity.entityName}</h2>
      </div>
      <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
        {/* Header */}
        <div className="flex flex-row justify-between items-center">
          <div className="flex flex-row gap-[10px]">
            <p className="text-black font-bold">Meeting Details</p>
          </div>
        </div>
        <div className="columns is-vcentered is-multiline qoutecard">
          {/* 1. Meeting Date & Time */}
          <div className="column is-4">
            <LabeledTextField
              rules={{ required: "Required" }}
              labelStyle={{
                fontSize: "12px",
                color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                fontWeight: "bold",
              }}
              label="Meeting Date & Time *"
              control={control}
              name="dateTime"
              type="datetime-local"
              size="small"
              fullWidth
              disabled={isView}
            />
          </div>

          {/* 2. Meeting Type */}
          <div className="column is-4">
            <AgSelectNewCH
              rules={{ required: "Required" }}
              isDisabled={{ disabled: isView }}
              label="Meeting Type *"
              placeholder={"Select Meeting Type"}
              name="type"
              dataList={[
                { label: "In-Person", value: "In-Person" },
                { label: "Video Call", value: "Video Call" },
                { label: "Phone Call", value: "Phone Call" },
              ]}
              callback={(e1) => setValue("type", e1)}
              value={formValues["type"]}
              isValid={getvaild("type")}
              validationMsg={"* Please select Meeting Type"}
            />
          </div>

          {/* 3. Meeting Outcome */}
          <div className="column is-4">
            <AgSelectNewCH
              rules={{ required: "Required" }}
              isDisabled={{ disabled: isView }}
              label="Meeting Outcome *"
              name="outcome"
              placeholder={"Select Outcome"}
              dataList={[
                { label: "Positive", value: "Positive" },
                { label: "Neutral", value: "Neutral" },
                { label: "Needs Follow-up", value: "Needs Follow-up" },
                { label: "Pending", value: "Pending" },
              ]}
              callback={(e1) => {
                setValue("outcome", e1);
                if (e1?.toLowerCase().replace(/[\s-]/g, "") !== "needsfollowup") {
                  setValue("followUpDate", "");
                  clearErrors("followUpDate");
                }
              }}
              value={formValues["outcome"]}
              isValid={getvaild("outcome")}
              validationMsg={"* Please select Meeting Outcome"}
            />
          </div>

          {/* Conditional Field: Next Follow-up Date (hidden by default, mandatory when Meeting Outcome is 'Needs Follow Up') */}
          {isNeedsFollowUp && (
            <div className="column is-4">
              <LabeledTextField
                rules={{ required: "Required" }}
                labelStyle={{
                  fontSize: "12px",
                  color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                  fontWeight: "bold",
                }}
                label="Next Follow-up Date *"
                control={control}
                name="followUpDate"
                type="date"
                size="small"
                fullWidth
                disabled={isView}
              />
            </div>
          )}

          {/* 4. Customer / Contact Name */}
          <div className="column is-4">
            <LabeledTextField
              placeholder="e.g. Aditya Sharma"
              labelStyle={{
                fontSize: "12px",
                color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                fontWeight: "bold",
              }}
              label="Customer / Contact Name *"
              control={control}
              name="customerName"
              type="string"
              size="small"
              fullWidth
              rules={{ required: "Required" }}
              disabled={isView}
            />
          </div>

          {/* 5. Internal Attendees */}
          <div className="column is-4">
            <MultiSelectField
              labelStyle={{
                fontSize: "12px",
                color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                fontWeight: "bold",
              }}
              name="internalAttendees"
              control={control}
              label={"Internal Attendees"}
              placeholder="Your team members attending (Email)"
              madatory={true}
              options={agActiveList}
              disabled={isView}
              rules={{
                validate: (v) => (v && v.length > 0) || "Required",
              }}
            />
          </div>

          {/* 6. Meeting Notes */}
          <div className="column is-12">
            <LabeledTextField
              placeholder="Topics discussed, decisions made, action items…"
              labelStyle={{
                fontSize: "12px",
                color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                fontWeight: "bold",
              }}
              label="Meeting Notes *"
              control={control}
              name="meetingNotes"
              multiline
              rows={3}
              fullWidth
              disabled={isView}
              rules={{ required: "Required" }}
            />
          </div>
        </div>
      </div>
      {/* Optional Fields Section */}
      <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px] mt-2">
        <div className="flex flex-row justify-between items-center">
          <div className="flex flex-row gap-[10px]">
            <p className="text-black font-bold">Additional Details</p>
          </div>
        </div>
        <div className="columns is-vcentered is-multiline qoutecard">
          {/* 1. Meeting Location / Link */}
          <div className="column is-4">
            <LabeledTextField
              placeholder="e.g. Office, Zoom link, Google Meet URL…"
              labelStyle={{
                fontSize: "12px",
                color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                fontWeight: "bold",
              }}
              label="Meeting Location / Link"
              control={control}
              name="location"
              type="string"
              size="small"
              fullWidth
              disabled={isView}
            />
          </div>

          {/* 2. Meeting Duration */}
          <div className="column is-4">
            <AgSelectNewCH
              isDisabled={{ disabled: isView }}
              label="Meeting Duration"
              name="duration"
              placeholder={"Select Duration"}
              dataList={[
                { label: "15 min", value: "15 min" },
                { label: "30 min", value: "30 min" },
                { label: "45 min", value: "45 min" },
                { label: "1 hour", value: "1 hour" },
                { label: "1.5 hour", value: "1.5 hour" },
                { label: "2 hour", value: "2 hour" },
              ]}
              callback={(e1) => setValue("duration", e1)}
              value={formValues["duration"]}
            />
          </div>

          {/* 3. Branch */}
          {formValues["branch"] || props.mode === "new" ? (
            <div className="column is-4">
              <AgSelectNewCH
                isDisabled={{ disabled: isView }}
                label="Branch"
                name="branch"
                placeholder={"Select Branch"}
                dataList={Entity.branch.map((data) => {
                  return {
                    label: data.state,
                    value: data.state,
                  };
                })}
                callback={(e1) => {
                  setValue("branch", e1);
                }}
                value={formValues["branch"]}
                validationMsg={"* Please select Branch"}
              />
            </div>
          ) : (
            <></>
          )}

          {/* 4. Email */}
          <div className="column is-4">
            <LabeledTextField
              placeholder="customer@example.com"
              labelStyle={{
                fontSize: "12px",
                color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                fontWeight: "bold",
              }}
              label="Email"
              control={control}
              name="email"
              type="email"
              size="small"
              fullWidth
              disabled={isView}
            />
          </div>

          {/* 5. Phone Number */}
          <div className="column is-4">
            <PhoneFieldnew
              labelStyle={{
                fontSize: "12px",
                color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                fontWeight: "bold",
              }}
              callback={(e) => {
                if (ManageCRMStore.manageCRMRec.phoneNumber != e?.number) {
                  ManageCRMStore.manageCRMRec.phoneNumber = e?.number;
                  setValue("phoneNumber", e.number);
                }
                if (ManageCRMStore.manageCRMRec.phoneCountryCode != e?.code) {
                  ManageCRMStore.manageCRMRec.phoneCountryCode = e?.code;
                  setValue("phoneCountryCode", e.code);
                }
              }}
              countryCode={ManageCRMStore.manageCRMRec.phoneCountryCode}
              name="phoneNumber"
              control={control}
              disabled={isView}
            />
          </div>
          {/* 6. External Attendees */}
          <div className="column is-4">
            <MultiSelectField
              labelStyle={{
                fontSize: "12px",
                color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                fontWeight: "bold",
              }}
              name="externalAttendees"
              control={control}
              label={"External Attendees"}
              placeholder="Customer-side participants (Name or Email)"
              options={agEntityActiveList}
              onInputChangeValue={onInputChangeValue}
              callback={externalChangeValue}
              disabled={isView}
            />
          </div>

          {/* 7. Agenda / Purpose */}
          <div className="column is-12">
            <LabeledTextField
              placeholder="What is this meeting about? Key topics to cover…"
              labelStyle={{
                fontSize: "12px",
                color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                fontWeight: "bold",
              }}
              label="Agenda / Purpose"
              control={control}
              name="agenda"
              multiline
              rows={2}
              fullWidth
              disabled={isView}
            />
          </div>
        </div>
      </div>
      <hr /><div
                      className="field is-grouped"
                      style={{ display: "flex", justifyContent: "flex-start" }}
                    >
                     {
        props.mode != "view" &&  <div className="control">
                        <button
                          className="button"
                          style={{
                            backgroundColor:
                              process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                            color: "#fff",
                          }}
                          onClick={async (e) => {
                            const isValid = await trigger();
                            const hasInternalAttendees =
                              formValues["internalAttendees"] &&
                              formValues["internalAttendees"].length > 0;
                            const hasFollowUpDate =
                              !isNeedsFollowUp || Boolean(formValues["followUpDate"]);
                            const isFormValid =
                              isValid &&
                              hasInternalAttendees &&
                              hasFollowUpDate &&
                              Boolean(formValues["type"]) &&
                              Boolean(formValues["outcome"]);
                            setValid(isFormValid);
                            if (isFormValid) {
                              handleSubmit(onSubmit)();
                            } else {
                              configStore.setModalMessage(`Please check the fields`);
                            }
                          }}
                        >
                          {(props.mode == "new")?"Submit":"Update"}
                        </button>
                      </div>
                      }
                      
                      <div className="control">
                        <button
                          class="button is-danger"
                          onClick={() => {
                            routerStore.managecrmTabView = "meetingDetails"
                            routerStore.managecrmCurrentViewNew = "list"
                          }}
                        >
                          {(props.mode == "view")?"Close":"Cancel"}                          
                        </button>
                      </div>
                    </div>
      
      
    </>
  );
}

export default EditCrm;
